import { useNavigate } from 'react-router-dom';
import { BarChart3, Users, Receipt, FileText } from 'lucide-react';
import { useThemeStore } from '../../stores/theme.store';

const reportCards = [
  {
    icon: BarChart3,
    title: 'Relatório Consolidado',
    description: 'Visão geral de entradas, saídas, receitas e lucro',
    route: '/admin/reports/consolidated',
  },
  {
    icon: Users,
    title: 'Por Correntista',
    description: 'Análise detalhada por correntista com ranking',
    route: '/admin/reports/per-customer',
  },
  {
    icon: Receipt,
    title: 'Taxas e Mensalidades',
    description: 'Receita de taxas, mensalidades e projeções',
    route: '/admin/reports/fees-membership',
  },
  {
    icon: FileText,
    title: 'Transações Detalhadas',
    description: 'Listagem completa com detecção de anomalias',
    route: '/admin/reports/detailed-transactions',
  },
];

export function ReportsHubPage() {
  const { isDarkMode } = useThemeStore();
  const navigate = useNavigate();

  const bg = isDarkMode ? 'bg-gray-900' : 'bg-gray-50';
  const cardBg = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const textPrimary = isDarkMode ? 'text-white' : 'text-gray-900';
  const textSecondary = isDarkMode ? 'text-gray-400' : 'text-gray-500';

  return (
    <div className={`min-h-screen ${bg} p-6`}>
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <h1 className={`text-2xl font-bold ${textPrimary}`}>Relatórios Financeiros</h1>
          <p className={`mt-1 ${textSecondary}`}>
            Selecione um relatório para visualizar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reportCards.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.route}
                className={`${cardBg} rounded-xl p-6 flex flex-col gap-4 shadow-sm`}
              >
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-blue-500/10">
                    <Icon className="w-6 h-6 text-blue-500" />
                  </div>
                  <h2 className={`text-lg font-semibold ${textPrimary}`}>{card.title}</h2>
                </div>
                <p className={`${textSecondary} text-sm`}>{card.description}</p>
                <button
                  onClick={() => navigate(card.route)}
                  className="mt-auto self-start px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
                >
                  Acessar
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
